import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {environment} from '../../../environments/environment';
import {KeycloakProfile} from 'keycloak-js';
import {Utils} from '../../classes/utils';

@Component({
    selector: 'gp-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css'],
    standalone: false
})
export class ToolbarComponent implements OnInit {

	user: KeycloakProfile;
	isLoggedIn: boolean;

	constructor(
		public utils : Utils,
		private router: Router,
		public keycloak: KeycloakService
	) {
	}

	async ngOnInit() {
		this.isLoggedIn = await this.keycloak.isLoggedIn();
		if (this.isLoggedIn) {
			this.keycloak.loadUserProfile().then(user => {
				this.user = user;
			});
		}
	}

	onLogout() {
		this.keycloak.logout(environment.loginUrl)
	}

}
